import { Breakpoints, styled } from '@volkswagen-onehub/components-core';
import { Text, designTokens } from '@volkswagen-onehub/components-core';
import { alignVals } from './PriceBreakdownTable';

interface PriceBreakdownTableWrapperProps {
  stackedDesktop?: boolean;
  alignDesktop?: alignVals;
}

export const PriceBreakdownTableWrapper =
  styled.div<PriceBreakdownTableWrapperProps>(
    ({ theme, stackedDesktop, alignDesktop }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.size.static250};

  ${
    !stackedDesktop
      ? `
    @media (min-width: ${Breakpoints.b960}px) {
        flex-direction: row;
        flex-flow: wrap;
        justify-content: ${alignDesktop};
        gap: ${theme.size.static550};

    }
  `
      : ``
  }
`
  );

export const Price = styled.div<PriceBreakdownTableWrapperProps>(
  ({ theme, stackedDesktop }) => `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${theme.size.static100};

  ${
    !stackedDesktop
      ? `
    @media (min-width: ${Breakpoints.b960}px) {
        flex-direction: column;
        justify-content: space-between;
        gap: ${theme.size.static300};
    }`
      : ``
  }
`
);

export const PriceLabel = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Info = styled(Text)(
  ({ theme }) => `
  color: ${theme.colors.content.tertiary};
`);
